import { DateValue } from '@affine/core/components/workspace-property-types/date';
import {
  dateValueToNormalized,
  normalizedToDateValue,
} from '@affine/core/components/workspace-property-types/date-value';
import { normalizeDateRange } from '@blocksuite/data-view/property-presets';
import type { LiveData } from '@toeverything/infra';
import { useLiveData } from '@toeverything/infra';

import type { DatabaseCellRendererProps } from '../../../types';

/**
 * A `date-range` cell always stores `{ start, end, hasTime }`. The doc-property
 * editor speaks a string codec instead, so both directions go through the
 * bridge in `date-value.ts` — otherwise the range typed here is lost on save.
 */
export const DateRangeCell = ({
  cell,
  rowId,
  dataSource,
  onChange,
}: DatabaseCellRendererProps) => {
  const value = useLiveData(cell.value$ as LiveData<unknown>);
  const normalized = normalizeDateRange(value ?? null);

  return (
    <DateValue
      value={normalized ? normalizedToDateValue(normalized) : ''}
      onChange={v => {
        const parsed = v ? dateValueToNormalized(v) : undefined;
        const next = parsed
          ? {
              start: parsed.start,
              end: parsed.end ?? parsed.start,
              hasTime: parsed.hasTime,
            }
          : null;
        dataSource.cellValueChange(rowId, cell.property.id, next);
        onChange?.(next);
      }}
    />
  );
};
